import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type HasUnreadNotificationsFragment = { __typename?: 'Account', id: string, notificationGroups: { __typename?: 'NotificationGroupConnection', hasUnreads?: boolean | null } };

export const HasUnreadNotifications = /*#__PURE__*/ gql`
    fragment HasUnreadNotifications on Account {
  id
  notificationGroups(page: {first: 100}) {
    hasUnreads
  }
}
    ` as unknown as DocumentNode<HasUnreadNotificationsFragment, unknown>;

        

        
export const useHasUnreadNotificationsFragment = (
  input: string | Omit<UseFragmentOptions<HasUnreadNotificationsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<HasUnreadNotificationsFragment>({
    fragment: HasUnreadNotifications,
    fragmentName: 'HasUnreadNotifications',
    ...options,
  });
};
  
        